export default __webpack_public_path__ + "static/media/carpet.d5693d37.png";